import React, { useState, useEffect } from "react";
import Menu from "./Menu";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";

function HMG() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    file: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    fetch("/files/HMG.json")
      .then((res) => res.json())
      .then((data) => {
        const formatted = data
          .filter((filename) => filename !== "index.json")
          .sort((a, b) => a.localeCompare(b))
          .map((filename) => ({ file: filename }));
        setFiles(formatted);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading file list", err);
        setLoading(false);
      });
  }, []);

  const actionBodyTemplate = (rowData) => {
    const fileUrl = `${window.location.origin}/files/HMG/${rowData.file}`;
    return (
      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
        <Button
          label="Open"
          icon="pi pi-external-link"
          className="p-button-text p-button-sm p-button-secondary"
          style={{ color: "white", backgroundColor: "#007BFF", border: "none" }}
        />
      </a>
    );
  };

  return (
    <>
      <Menu />

      <div className="card p-1">
        <h2>
          <center>HMG</center>
        </h2>

        <DataTable
          loading={loading}
          value={files}
          paginator
          rows={10}
          sortMode="multiple"
          tableStyle={{ minWidth: "60rem" }}
          removableSort
          stripedRows
          resizableColumns
          dataKey="file"
          filterDisplay="row"
          filters={filters}
          onFilter={(e) => setFilters(e.filters)}
        >
          <Column
            header="#"
            body={(rowData, options) => options.rowIndex + 1}
            style={{ width: "3rem" }}
          />
          <Column
            field="file"
            header="File"
            sortable
            filter
            filterPlaceholder="Search file name"
          />
          <Column
            header="Open"
            body={actionBodyTemplate}
            style={{ minWidth: "3rem" }}
          />
        </DataTable>
      </div>
    </>
  );
}

export default HMG;
